// react-svg siempre agrega role="img" al <svg> inyectado. Cuando el icono es
// decorativo (el boton o link que lo contiene ya tiene su propio aria-label o
// texto visible al lado), hay que sacarlo del accessibility tree en vez de
// dejar un role="img" sin nombre accesible.
export const hideDecorativeSvg = (svg: SVGElement) => {
  svg.setAttribute('aria-hidden', 'true');
};

// Para el caso contrario: el svg es la unica forma de identificar el control
// y no hay texto ni aria-label alrededor.
export const nameSvg = (label: string) => (svg: SVGElement) => {
  svg.setAttribute('role', 'img');
  svg.setAttribute('aria-label', label);
};
